<template>
  <div :loading="logging" class="loginForm">
    <h1 v-if="!checkout" class="mt-5 mb-3 text-h3">Entrar</h1>
    <div>Já tem uma conta?</div>
    <v-form>
      <v-text-field
        :disabled="logging"
        append-icon="person"
        name="email"
        label="Email"
        type="text"
        required
        outlined
        dense
        hide-details="auto"
        v-model="model.email"
        v-validate="'required|email'"
        :v-errors="errors"
        :error-messages="errors.collect('email')"
        data-vv-name="email"
        style="margin-bottom: 14px"
        v-on:keyup.13="login"
      >
      </v-text-field>
      <v-text-field
        :disabled="logging"
        :append-icon="showPass1 ? 'visibility' : 'visibility_off'"
        name="password"
        label="Senha"
        :type="showPass1 ? 'text' : 'password'"
        outlined
        dense
        hide-details="auto"
        @click:append="showPass1 = !showPass1"
        v-model="model.password"
        data-vv-name="senha"
        v-validate="'required'"
        v-on:keyup.13="login"
        :v-errors="errors"
        :error-messages="errors.collect('senha')"
        required
      >
      </v-text-field>
    </v-form>
    <v-btn
      small
      text
      style="align-self: end; margin-top: -10px; padding: 2px"
      :to="{ name: 'password.request' }"
      >Esqueci a senha</v-btn
    >
    <v-btn
      rounded
      class="elevation-0"
      color="primary"
      style="margin: -8px 0 0"
      :loading="logging"
      @click="login"
    >
      Entrar
    </v-btn>
    <v-btn rounded outlined @click.prevent="auth('facebook')">
      <v-icon class="mr-2" color="blue">fa fa-facebook-square fa-lg</v-icon>
      Entre com Facebook
    </v-btn>

    <v-btn rounded outlined @click.prevent="auth('google')">
      <v-icon class="mr-2" color="red">fa fa-google fa-lg</v-icon>
      Entre com Google
    </v-btn>
    <div class="mt-3 ml-1">Não tem uma conta?</div>
    <v-btn
      rounded
      outlined
      color="primary"
      :to="'/register?redirect=' + $route.path"
    >
      Criar conta
    </v-btn>
  </div>
</template>

<script>
import {
  makeLogin,
  makeLoginByToken,
  socialLogin,
} from "@/services/auth.service";
import { mapGetters } from "vuex";
import { makeLogout } from "../../../services/auth.service";

import { CONFIG } from "@/config";
export default {
  props: {
    redirect: {
      required: false,
      default: undefined,
    },
    hideRemember: {
      required: false,
      default: false,
    },
    checkout: {
      required: false,
      default: false,
    },
  },
  data: () => ({
    logging: false,
    showPass1: false,
    model: {
      email: "",
      password: "",
    },
  }),
  computed: mapGetters({
    user: "authUser",
    authenticated: "authCheck",
  }),
  async mounted() {
    console.log("looog", this.$route.query);
    console.log("looog2", this.$route);

    if (this.$route.query.token) {
      this.logging = true;
      await makeLogout();
      makeLoginByToken(this.$route.query.token)
        .then((response) => {
          this.createSession(response.data);
          this.$gtag.query("event", "login", {
            method: "token",
          });
          if (this.redirect) {
            let to = "/courses";
            if (this.$route.query.redirect) {
              to = this.$route.query.redirect;
            }
            this.$router.push(to);
          }
          this.logging = false;
        })
        .catch((ex) => {
          this.logging = false;
          window.getApp.sendSnackMessage(ex.message, "error");
        });
    }
  },
  methods: {
    async login() {
      if (navigator.onLine === false) {
        window.getApp.sendSnackMessage(
          "Você está offline, não é possivel entrar na plataforma.",
          "error",
        );
        return;
      }
      if (await this.formHasErrors()) return;
      this.logging = true;

      makeLogin(this.model)
        .then(async (response) => {
          await this.createSession(response.data);
          if (this.redirect) {
            let to = "/courses";
            if (this.$route.query.redirect) {
              to = this.$route.query.redirect;
            }
            this.$router.push(to);
          }
          this.$emit("login", true);
          this.logging = false;

          this.$gtag.event("login", {
            method: "email",
          });
          caches.open(CONFIG.CACHEV).then(function (cache) {
            return cache.addAll(["/api/v1/me"]);
          });
        })
        .catch((ex) => {
          this.$emit("login", false);
          // console.log(JSON.stringify(ex))
          this.logging = false;
          if (ex.status === 400) {
            this.$router.push("/courses");
          } else {
            window.getApp.sendSnackMessage(ex.message, "error");
          }
        });
    },
    async createSession(authData) {
      console.log("creating session");
      await this.$store.dispatch("saveToken", {
        token: authData.token,
      });
      // Fetch the user
      await this.$store.dispatch("fetchUser");
    },
    auth: function (network) {
      const _this = this;
      const hello = this.hello;
      hello(network)
        .login({
          scope: "email",
          force: false,
          auth_type: "rerequest",
        })
        .then(() => {
          const authRes = hello(network).getAuthResponse();
          /*
            performs operations using the token from authRes
          */
          this.logging = true;
          hello(network)
            .api("me")
            .then(function (profile) {
              /*
                performs operations using the user info from profile
              */
              socialLogin(authRes, profile, network).then(async (r) => {
                // console.log(r)
                await _this.createSession(r.data);
                if (_this.redirect) {
                  const to = _this.$route.query.redirect || "/courses";
                  await _this.$router.push(to);
                }
                _this.logging = false;
                _this.$emit("logged", _this.user);
                _this.$gtag.query("event", "login", {
                  method: network,
                });
              });
              // console.log(_this.redirect)
            });
        });
      this.logging = false;
    },
  },
};
</script>
<style scoped lang="scss">
.loginForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
  width: 100%;
  max-width: 330px;
}
</style>
